import { createAction } from '@reduxjs/toolkit';
import {
  ApiPaginationResponse,
  TableQueryParameters,
} from 'src/components/ui/Table/Table.interface';

import { Company, ListCompany } from '../models/Company';

export const COMPANY_SLICE = 'company';

/* Get company list */
export const getCompanyList = createAction<{
  params: TableQueryParameters<void, ListCompany>;
}>(`${COMPANY_SLICE}/getCompanyList`);

/* Set company list */
export const setCompanyList = createAction<
  ApiPaginationResponse<ListCompany[]>
>(`${COMPANY_SLICE}/setCompanyList`);

/* Get company details */
export const getCompanyDetails = createAction<{ companyId: string }>(
  `${COMPANY_SLICE}/getCompanyDetails`
);

/* Set company details */
export const setCompanyDetails = createAction<Company>(
  `${COMPANY_SLICE}/setCompanyDetails`
);

/* Add company */
export const addCompany = createAction<Company>(`${COMPANY_SLICE}/addCompany`);

/* Edit company */
export const editCompany = createAction<Company>(
  `${COMPANY_SLICE}/editCompany`
);

/* Remove company */
export const removeCompany = createAction<{
  company: Company;
  fullRemove: boolean;
}>(`${COMPANY_SLICE}/removeCompany`);
